// «الصيانة» strings. Merged into translations by i18n.js.
// Keys are mt_* (plus the permission-editor group label); both languages carry the same key set.
export const MAINT_STRINGS = {
    ar: {
        perm_cap_group_maintenance: "الصيانة",
        mt_title: "الصيانة",
        mt_subtitle: "طلبات الصيانة وأوامر العمل من نظام الصيانة، لكل فرع",
        mt_last_sync: "آخر مزامنة",
        mt_never_synced: "لم تتم أي مزامنة بعد",
        mt_sync_every: "تتم المزامنة كل {m} دقيقة",
        mt_sync_running: "جارٍ المزامنة…",
        mt_run_now: "مزامنة الآن",
        mt_run_ok: "تمت المزامنة",
        mt_run_pending: "بدأت المزامنة، ستظهر النتيجة بعد قليل",
        mt_not_configured: "الربط مع نظام الصيانة غير مضبوط",
        mt_not_configured_hint: "يشغّل المالك backend/scripts/maint_feed_keygen.py على خادم المنصة (يضيف MAINT_FEED_SIGNING_KEY)، ثم يضع سطر OPS_FEED_PUBLIC_KEY الذي يطبعه في إعدادات نظام الصيانة ويعيد تشغيل الخادم.",
        mt_not_configured_invalid: "مفتاح التوقيع MAINT_FEED_SIGNING_KEY غير صالح",
        mt_not_configured_url: "عنوان نظام الصيانة MAINT_FEED_URL غير مقبول",
        mt_not_configured_url_hint: "يجب أن يبدأ العنوان بـ https://",
        mt_auto_sync: "مزامنة تلقائية",
        mt_auto_sync_off: "المزامنة التلقائية متوقفة",
        mt_auto_sync_saved_on: "تم تشغيل المزامنة التلقائية",
        mt_auto_sync_saved_off: "تم إيقاف المزامنة التلقائية",
        mt_last_error: "تعذرت آخر مزامنة",
        mt_showing_from: "البيانات المعروضة من مزامنة",
        mt_truncated: "آخر نسخة من نظام الصيانة غير كاملة، لذلك لم يُعلَّم أي سجل كمحذوف.",
        mt_err_not_configured: "الربط غير مضبوط",
        mt_err_busy: "توجد مزامنة قيد التشغيل",
        mt_err_unauthorized: "رفض نظام الصيانة توقيع الربط",
        mt_err_feed_disabled: "الربط غير مفعّل في نظام الصيانة",
        mt_err_timeout: "انتهت مهلة الاتصال بنظام الصيانة",
        mt_err_network: "تعذر الوصول إلى نظام الصيانة",
        mt_err_http_error: "أعاد نظام الصيانة خطأ",
        mt_err_redirect: "حوّل نظام الصيانة الطلب إلى عنوان آخر",
        mt_err_bad_json: "بيانات غير مقروءة من نظام الصيانة",
        mt_err_bad_shape: "بيانات غير متوافقة من نظام الصيانة",
        mt_err_bad_version: "إصدار بيانات غير مدعوم من نظام الصيانة",
        mt_err_too_large: "حجم البيانات من نظام الصيانة أكبر من المسموح",
        mt_err_internal: "خطأ داخلي أثناء المزامنة",
        mt_from: "من",
        mt_to: "إلى",
        mt_preset_7: "7 أيام",
        mt_preset_30: "30 يومًا",
        mt_preset_90: "90 يومًا",
        mt_preset_mtd: "هذا الشهر",
        mt_range_note: "المفتوح والمتأخر وما ينتظر الإغلاق أو التأكيد كما هو الآن؛ بقية المؤشرات ضمن الفترة المختارة (بتوقيت الرياض).",
        mt_kpi_open_requests: "طلبات مفتوحة",
        mt_kpi_open_work_orders: "أوامر عمل مفتوحة",
        mt_kpi_overdue: "متأخرة عن الوقت المستهدف",
        mt_kpi_awaiting_close: "بانتظار الإغلاق",
        mt_kpi_awaiting_branch: "بانتظار تأكيد الفرع",
        mt_kpi_met_target: "أُنجزت ضمن الوقت المستهدف",
        mt_kpi_ttc: "مدة الإنجاز",
        mt_kpi_first_response: "سرعة الاستجابة",
        mt_kpi_repeat: "أعطال متكررة",
        mt_kpi_parts_cost: "تكلفة القطع",
        mt_kpi_requests_created: "طلبات جديدة في الفترة",
        mt_kpi_completed: "أوامر أُنجزت في الفترة",
        mt_median: "الوسيط",
        mt_avg: "المتوسط",
        mt_met_of: "{met} من {n}",
        mt_computed_n: "{n} محسوبة من الأوقات",
        mt_ttc_hint: "من الإسناد حتى الإنجاز",
        mt_fr_hint: "من فتح الطلب حتى إسناده",
        mt_repeat_hint: "نفس الموقع، ونفس سبب العطل أو الأصل، خلال 30 يومًا",
        mt_unit_min: "د",
        mt_unit_hour: "س",
        mt_unit_day: "ي",
        mt_sar: "ر.س",
        mt_branches_title: "حسب الفرع",
        mt_col_branch: "الفرع",
        mt_col_open_requests: "طلبات مفتوحة",
        mt_col_open_work_orders: "أوامر مفتوحة",
        mt_col_overdue: "متأخرة",
        mt_col_awaiting_close: "بانتظار الإغلاق",
        mt_col_awaiting_branch: "بانتظار التأكيد",
        mt_col_met: "ضمن الوقت",
        mt_col_ttc: "متوسط الإنجاز",
        mt_col_repeat: "متكررة",
        mt_col_parts_cost: "تكلفة القطع",
        mt_suggested: "مطابقة مقترحة",
        mt_unmapped: "غير مربوط بفرع",
        mt_no_rows: "لا توجد مواقع صيانة بعد",
        mt_tech_title: "عبء الفنيين",
        mt_tech_open: "مفتوحة",
        mt_tech_overdue: "متأخرة",
        mt_tech_completed: "أُنجزت في الفترة",
        mt_tech_unknown: "فني غير معروف",
        mt_tech_none: "لا توجد أوامر عمل مسندة",
        mt_lists_title: "الطلبات وأوامر العمل",
        mt_tab_wo: "أوامر العمل",
        mt_tab_wr: "طلبات الصيانة",
        mt_f_status: "الحالة",
        mt_f_branch: "الفرع",
        mt_f_criticality: "الأهمية",
        mt_f_overdue: "المتأخرة فقط",
        mt_status_open: "المفتوحة",
        mt_status_all: "الكل",
        mt_status_awaiting_close: "بانتظار الإغلاق",
        mt_status_awaiting_branch: "بانتظار تأكيد الفرع",
        mt_all_branches: "كل الفروع",
        mt_all: "الكل",
        mt_open_note: "المفتوحة وما ينتظر الإغلاق أو التأكيد تُعرض كلها مهما كان تاريخ فتحها.",
        mt_range_applies: "ضمن الفترة المختارة حسب تاريخ الفتح.",
        mt_list_empty: "لا توجد عناصر بهذه الفلاتر",
        mt_overdue_by: "متأخر {d}",
        mt_prev: "السابق",
        mt_next: "التالي",
        mt_page_of: "صفحة {p} من {n} · {total} عنصر",
        mt_st_new: "جديد",
        mt_st_accepted: "مقبول",
        mt_st_rejected: "مرفوض",
        mt_st_assigned: "مُسند",
        mt_st_in_progress: "قيد التنفيذ",
        mt_st_completed: "مُنجز",
        mt_st_closed: "مغلق",
        mt_st_reopened: "أعيد فتحه",
        mt_st_cancelled: "ملغى",
        mt_st_on_hold: "معلّق",
        mt_cr_low: "منخفضة",
        mt_cr_medium: "متوسطة",
        mt_cr_normal: "عادية",
        mt_cr_high: "عالية",
        mt_cr_urgent: "عاجلة",
        mt_cr_critical: "حرجة",
        mt_cr_emergency: "طارئة",
        mt_cr_unknown: "غير محددة",
        mt_item_wr: "طلب صيانة",
        mt_item_wo: "أمر عمل",
        mt_fld_location: "الموقع",
        mt_fld_branch: "الفرع",
        mt_fld_sub_unit: "القسم",
        mt_fld_asset: "الأصل",
        mt_fld_status: "الحالة",
        mt_fld_criticality: "الأهمية",
        mt_fld_technician: "الفني",
        mt_fld_sla: "الوقت المستهدف",
        mt_fld_ttc: "مدة الإنجاز",
        mt_fld_actual: "الوقت الفعلي المسجل",
        mt_fld_sla_met: "ضمن الوقت المستهدف؟",
        mt_fld_created_by: "فتحه",
        mt_fld_created_at: "تاريخ الفتح",
        mt_fld_branch_confirmed: "تأكيد الفرع",
        mt_desc: "الوصف",
        mt_timeline: "المراحل",
        mt_root_cause: "سبب العطل",
        mt_parts: "القطع المستخدمة",
        mt_parts_none: "لم تُسجل قطع",
        mt_parts_total: "إجمالي تكلفة القطع",
        mt_part_name: "القطعة",
        mt_part_qty: "الكمية",
        mt_part_unit: "سعر الوحدة",
        mt_part_total: "الإجمالي",
        mt_photos: "الصور",
        mt_photos_before: "قبل",
        mt_photos_after: "بعد",
        mt_photos_none: "لا توجد صور",
        mt_photo_broken: "تعذر عرض الصورة",
        mt_photos_unavailable: "الصور غير متاحة",
        mt_photos_some_unavailable: "{n} صورة غير متاحة",
        mt_photos_loading: "جارٍ تحميل الصور…",
        mt_no_location: "بدون موقع",
        mt_voice_note: "ملاحظة صوتية",
        mt_voice_note_hint: "فيه ملاحظة صوتية — استمع إليها في نظام الصيانة",
        mt_open_in_maint: "فتح في نظام الصيانة",
        mt_close: "إغلاق",
        mt_linked_wo: "أمر العمل المرتبط",
        mt_linked_wr: "الطلب الأصلي",
        mt_rejection: "سبب الرفض",
        mt_close_reason: "سبب الإغلاق",
        mt_reopen_reason: "سبب إعادة الفتح",
        mt_yes: "نعم",
        mt_no: "لا",
        mt_not_recorded: "غير مسجل",
        mt_basis_computed: "محسوب من الأوقات",
        mt_basis_feed: "من نظام الصيانة",
        mt_repeat_of: "عطل متكرر: سبقه أمر عمل مشابه في نفس الموقع خلال 30 يومًا",
        mt_ev_created: "فُتح",
        mt_ev_assigned: "أُسند",
        mt_ev_wo_assigned: "أُسند أمر العمل",
        mt_ev_started: "بدأ العمل",
        mt_ev_ended: "انتهى العمل",
        mt_ev_completed: "أُنجز",
        mt_ev_closed: "أُغلق",
        mt_ev_branch_confirmed: "أكّده الفرع",
        mt_ev_reopened: "أعيد فتحه",
        mt_ev_rejected: "رُفض",
        mt_ev_by: "بواسطة",
        mt_ev_to: "إلى",
        mt_branch_months: "تكلفة القطع شهريًا",
        mt_branch_repeats: "الأعطال المتكررة في الفترة",
        mt_branch_locations: "مواقع الصيانة",
        mt_branch_show_items: "عرض أوامر عمل هذا الفرع",
        mt_no_repeats: "لا أعطال متكررة في الفترة",
        mt_map_title: "ربط مواقع الصيانة بالفروع",
        mt_map_hint: "اقتُرح الربط تلقائيًا بمطابقة الاسم العربي. أكّد أو عدّل؛ الربط المؤكد لا تغيّره المزامنة.",
        mt_map_location: "موقع الصيانة",
        mt_map_branch: "فرع منصة العمليات",
        mt_map_state_confirmed: "مؤكد",
        mt_map_state_suggested: "مطابقة مقترحة",
        mt_map_state_unmapped: "بلا فرع",
        mt_map_no_branch: "— لا يتبع فرعًا —",
        mt_map_save: "حفظ الربط",
        mt_map_saved: "تم حفظ الربط",
        mt_map_confirm_all: "تأكيد كل المقترحات",
        mt_map_confirm: "تأكيد",
        mt_map_reset: "إرجاع للمقترح",
        mt_map_changes: "{n} تغيير غير محفوظ",
        mt_map_empty: "لا توجد مواقع صيانة بعد؛ تظهر هنا بعد أول مزامنة ناجحة.",
        mt_empty_title: "لا توجد بيانات صيانة بعد",
        mt_empty_hint: "تظهر الطلبات وأوامر العمل هنا بعد أول مزامنة ناجحة مع نظام الصيانة.",
    },
    en: {
        perm_cap_group_maintenance: "Maintenance",
        mt_title: "Maintenance",
        mt_subtitle: "Maintenance requests and work orders from the maintenance system, by branch",
        mt_last_sync: "Last sync",
        mt_never_synced: "Not synced yet",
        mt_sync_every: "Syncs every {m} minutes",
        mt_sync_running: "Syncing…",
        mt_run_now: "Sync now",
        mt_run_ok: "Synced",
        mt_run_pending: "Sync started — the result shows shortly",
        mt_not_configured: "The maintenance system link is not configured",
        mt_not_configured_hint: "The owner runs backend/scripts/maint_feed_keygen.py on the ops server (it adds MAINT_FEED_SIGNING_KEY), puts the OPS_FEED_PUBLIC_KEY line it prints into the maintenance system's settings, and restarts the backend.",
        mt_not_configured_invalid: "The signing key MAINT_FEED_SIGNING_KEY is not valid",
        mt_not_configured_url: "The maintenance system address MAINT_FEED_URL is not accepted",
        mt_not_configured_url_hint: "The address must start with https://",
        mt_auto_sync: "Auto sync",
        mt_auto_sync_off: "Auto sync is off",
        mt_auto_sync_saved_on: "Auto sync turned on",
        mt_auto_sync_saved_off: "Auto sync turned off",
        mt_last_error: "The last sync failed",
        mt_showing_from: "Showing data from the sync of",
        mt_truncated: "The last snapshot from the maintenance system was incomplete, so nothing was marked removed.",
        mt_err_not_configured: "The link is not configured",
        mt_err_busy: "A sync is already running",
        mt_err_unauthorized: "The maintenance system rejected the link signature",
        mt_err_feed_disabled: "The link is switched off in the maintenance system",
        mt_err_timeout: "The maintenance system timed out",
        mt_err_network: "The maintenance system could not be reached",
        mt_err_http_error: "The maintenance system returned an error",
        mt_err_redirect: "The maintenance system redirected the request elsewhere",
        mt_err_bad_json: "Unreadable data from the maintenance system",
        mt_err_bad_shape: "Incompatible data from the maintenance system",
        mt_err_bad_version: "Unsupported data version from the maintenance system",
        mt_err_too_large: "The maintenance data is larger than allowed",
        mt_err_internal: "Internal error during the sync",
        mt_from: "From",
        mt_to: "To",
        mt_preset_7: "7 days",
        mt_preset_30: "30 days",
        mt_preset_90: "90 days",
        mt_preset_mtd: "This month",
        mt_range_note: "Open, overdue and awaiting figures are as of now; the rest are for the chosen period (Riyadh time).",
        mt_kpi_open_requests: "Open requests",
        mt_kpi_open_work_orders: "Open work orders",
        mt_kpi_overdue: "Past target time",
        mt_kpi_awaiting_close: "Awaiting close",
        mt_kpi_awaiting_branch: "Awaiting branch confirmation",
        mt_kpi_met_target: "Completed within target",
        mt_kpi_ttc: "Time to complete",
        mt_kpi_first_response: "First response",
        mt_kpi_repeat: "Repeat failures",
        mt_kpi_parts_cost: "Parts cost",
        mt_kpi_requests_created: "New requests in period",
        mt_kpi_completed: "Work orders completed in period",
        mt_median: "Median",
        mt_avg: "Average",
        mt_met_of: "{met} of {n}",
        mt_computed_n: "{n} computed from the times",
        mt_ttc_hint: "From assignment to completion",
        mt_fr_hint: "From request to assignment",
        mt_repeat_hint: "Same location and same root cause or asset within 30 days",
        mt_unit_min: "m",
        mt_unit_hour: "h",
        mt_unit_day: "d",
        mt_sar: "SAR",
        mt_branches_title: "By branch",
        mt_col_branch: "Branch",
        mt_col_open_requests: "Open requests",
        mt_col_open_work_orders: "Open WOs",
        mt_col_overdue: "Overdue",
        mt_col_awaiting_close: "Awaiting close",
        mt_col_awaiting_branch: "Awaiting confirm.",
        mt_col_met: "Within target",
        mt_col_ttc: "Avg completion",
        mt_col_repeat: "Repeats",
        mt_col_parts_cost: "Parts cost",
        mt_suggested: "Suggested match",
        mt_unmapped: "Not linked to a branch",
        mt_no_rows: "No maintenance locations yet",
        mt_tech_title: "Technician workload",
        mt_tech_open: "Open",
        mt_tech_overdue: "Overdue",
        mt_tech_completed: "Completed in period",
        mt_tech_unknown: "Unknown technician",
        mt_tech_none: "No assigned work orders",
        mt_lists_title: "Requests and work orders",
        mt_tab_wo: "Work orders",
        mt_tab_wr: "Maintenance requests",
        mt_f_status: "Status",
        mt_f_branch: "Branch",
        mt_f_criticality: "Criticality",
        mt_f_overdue: "Overdue only",
        mt_status_open: "Open",
        mt_status_all: "All",
        mt_status_awaiting_close: "Awaiting close",
        mt_status_awaiting_branch: "Awaiting branch confirmation",
        mt_all_branches: "All branches",
        mt_all: "All",
        mt_open_note: "Open and awaiting items are listed whatever their opening date.",
        mt_range_applies: "Within the chosen period, by opening date.",
        mt_list_empty: "Nothing matches these filters",
        mt_overdue_by: "{d} overdue",
        mt_prev: "Previous",
        mt_next: "Next",
        mt_page_of: "Page {p} of {n} · {total} items",
        mt_st_new: "New",
        mt_st_accepted: "Accepted",
        mt_st_rejected: "Rejected",
        mt_st_assigned: "Assigned",
        mt_st_in_progress: "In progress",
        mt_st_completed: "Completed",
        mt_st_closed: "Closed",
        mt_st_reopened: "Reopened",
        mt_st_cancelled: "Cancelled",
        mt_st_on_hold: "On hold",
        mt_cr_low: "Low",
        mt_cr_medium: "Medium",
        mt_cr_normal: "Normal",
        mt_cr_high: "High",
        mt_cr_urgent: "Urgent",
        mt_cr_critical: "Critical",
        mt_cr_emergency: "Emergency",
        mt_cr_unknown: "Not set",
        mt_item_wr: "Maintenance request",
        mt_item_wo: "Work order",
        mt_fld_location: "Location",
        mt_fld_branch: "Branch",
        mt_fld_sub_unit: "Section",
        mt_fld_asset: "Asset",
        mt_fld_status: "Status",
        mt_fld_criticality: "Criticality",
        mt_fld_technician: "Technician",
        mt_fld_sla: "Target time",
        mt_fld_ttc: "Time to complete",
        mt_fld_actual: "Recorded actual time",
        mt_fld_sla_met: "Within target?",
        mt_fld_created_by: "Opened by",
        mt_fld_created_at: "Opened",
        mt_fld_branch_confirmed: "Branch confirmation",
        mt_desc: "Description",
        mt_timeline: "Timeline",
        mt_root_cause: "Root cause",
        mt_parts: "Parts used",
        mt_parts_none: "No parts recorded",
        mt_parts_total: "Total parts cost",
        mt_part_name: "Part",
        mt_part_qty: "Qty",
        mt_part_unit: "Unit price",
        mt_part_total: "Total",
        mt_photos: "Photos",
        mt_photos_before: "Before",
        mt_photos_after: "After",
        mt_photos_none: "No photos",
        mt_photo_broken: "The photo could not be shown",
        mt_photos_unavailable: "Photos are not available",
        mt_photos_some_unavailable: "{n} photo(s) not available",
        mt_photos_loading: "Loading photos…",
        mt_no_location: "No location",
        mt_voice_note: "Voice note",
        mt_voice_note_hint: "Has a voice note — listen to it in the maintenance system",
        mt_open_in_maint: "Open in the maintenance system",
        mt_close: "Close",
        mt_linked_wo: "Linked work order",
        mt_linked_wr: "Original request",
        mt_rejection: "Rejection reason",
        mt_close_reason: "Close reason",
        mt_reopen_reason: "Reopen reason",
        mt_yes: "Yes",
        mt_no: "No",
        mt_not_recorded: "Not recorded",
        mt_basis_computed: "computed from the times",
        mt_basis_feed: "from the maintenance system",
        mt_repeat_of: "Repeat failure: a similar work order at this location within 30 days before it",
        mt_ev_created: "Opened",
        mt_ev_assigned: "Assigned",
        mt_ev_wo_assigned: "Work order assigned",
        mt_ev_started: "Work started",
        mt_ev_ended: "Work ended",
        mt_ev_completed: "Completed",
        mt_ev_closed: "Closed",
        mt_ev_branch_confirmed: "Confirmed by the branch",
        mt_ev_reopened: "Reopened",
        mt_ev_rejected: "Rejected",
        mt_ev_by: "by",
        mt_ev_to: "to",
        mt_branch_months: "Parts cost by month",
        mt_branch_repeats: "Repeat failures in period",
        mt_branch_locations: "Maintenance locations",
        mt_branch_show_items: "Show this branch's work orders",
        mt_no_repeats: "No repeat failures in the period",
        mt_map_title: "Link maintenance locations to branches",
        mt_map_hint: "Suggested automatically by matching the Arabic name. Confirm or edit; a confirmed link is never changed by a sync.",
        mt_map_location: "Maintenance location",
        mt_map_branch: "Ops platform branch",
        mt_map_state_confirmed: "Confirmed",
        mt_map_state_suggested: "Suggested match",
        mt_map_state_unmapped: "No branch",
        mt_map_no_branch: "— Not a branch —",
        mt_map_save: "Save links",
        mt_map_saved: "Links saved",
        mt_map_confirm_all: "Confirm all suggestions",
        mt_map_confirm: "Confirm",
        mt_map_reset: "Back to the suggestion",
        mt_map_changes: "{n} unsaved change(s)",
        mt_map_empty: "No maintenance locations yet; they appear here after the first good sync.",
        mt_empty_title: "No maintenance data yet",
        mt_empty_hint: "Requests and work orders show here after the first successful sync with the maintenance system.",
    },
};
